<script setup lang="ts">
import { type TServiceStep } from "@/assets/js/types";

const props = defineProps<{ step: TServiceStep }>();
</script>
<template>
	<div class="step">
		<div class="wrapp-title">
			<img :src="props.step.icon" />
			<div class="title">{{ props.step.title }}</div>
			<span class="separator"></span>

			<div class="sub-title">{{ step.subTitle }}</div>
		</div>
		<div class="txt">{{ step.text }}</div>
	</div>
</template>

<style lang="scss" scoped>
.step {
	font-family: Archivo, sans-serif;
	// background: #0a1a24f2;
	// background-color: #344349;
	color: #fff;
	width: 33%;
	// width: 368;
	min-height: 243px;
	padding: 24px;

	// NEW
	// border: 2px solid;
	// border-image: linear-gradient(
	// 		180deg,
	// 		rgba(146, 221, 242, 0.16),
	// 		rgba(56, 134, 152, 0.16)
	// 	)
	// 	1;
	// border-radius: 24px;
	// backdrop-filter: blur(9.1999px);
	// // box-shadow: 0 -11px 14.7px 0 #0a192052 inset;

	// // box-shadow: 0 5px 14px 0 #64c2d733 inset;

	// box-shadow:
	// 	inset 0 -11px 18px rgba(10, 25, 32, 0.32),
	// 	inset 0 5px 18px rgba(100, 194, 215, 0.2);

	border-radius: 24px;
	backdrop-filter: blur(9.2px);

	/* GRADIENT BORDER + BACKGROUND */
	background:
		linear-gradient(rgba(52, 67, 73, 0.95), rgba(52, 67, 73, 0.95)) padding-box,
		linear-gradient(180deg, rgba(146, 221, 242, 0.45), rgba(56, 134, 152, 0.45))
			border-box;
	border: 2px solid transparent;

	/* INSET SHADOW (ali slabiji uz ivicu) */
	box-shadow:
		inset 0 -12px 24px rgba(10, 25, 32, 0.45),
		inset 0 6px 20px rgba(100, 194, 215, 0.25);

	.wrapp-title {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-bottom: 32px;
	}
	.separator {
		width: 2px;
		height: 35px;
		background: #fff;
		margin-right: 10px;
	}
	.title {
		font-weight: 700;
		font-size: 32px;
		line-height: 100%;
		letter-spacing: 0%;
		margin: 0 10px;
		white-space: nowrap;
	}
	.sub-title {
		font-weight: 200;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: 0%;
		color: rgba(249, 249, 248, 0.691);
		white-space: nowrap;
	}
	.txt {
		font-weight: 400;
		font-size: 20px;
		line-height: 140%;
		letter-spacing: 0%;
	}
}
.step:hover {
	background:
		linear-gradient(rgba(52, 67, 73, 0.95), rgba(52, 67, 73, 0.95)) padding-box,
		linear-gradient(180deg, rgba(160, 235, 255, 0.55), rgba(80, 170, 190, 0.55))
			border-box;
}

@media screen and (width <= 768px) {
	.step {
		width: 100%;
		// width: 368;
		min-height: 145px;
		border-radius: 24px;
		padding: 24px 16px;
		// margin-bottom: 24px;

		.title {
			font-size: 24px;
		}
		.sub-title {
			font-size: 20px;
		}
		.txt {
			font-size: 16px;
		}
	}
}
</style>
